import { defineStore } from 'pinia'

export const useMainStore = defineStore('main', () => {
  const isDesktop = ref(false)
  const isMobile = ref(false)
  const isHoverSupported = ref(false)
  const isPortrait = ref(false)
  const isLandscape = ref(false)
  const isMobileDevice = ref(false)
  /** 'ios' | 'android' | null — set by the detect-screen server plugin
   *  so app-promo surfaces can pick the right store link / banner without
   *  duplicating UA sniffing. */
  const mobilePlatform = ref(null)

  function setIsDesktop(value) {
    isDesktop.value = value
  }

  function setIsMobile(value) {
    isMobile.value = value
  }

  function setIsHoverSupported(value) {
    isHoverSupported.value = value
  }

  function setIsPortrait(value) {
    isPortrait.value = value
  }

  function setIsLandscape(value) {
    isLandscape.value = value
  }

  function setIsMobileDevice(value) {
    isMobileDevice.value = value
  }

  function setMobilePlatform(value) {
    mobilePlatform.value = value
  }

  return {
    isDesktop,
    isMobile,
    isHoverSupported,
    isPortrait,
    isLandscape,
    isMobileDevice,
    mobilePlatform,
    setIsDesktop,
    setIsMobile,
    setIsHoverSupported,
    setIsPortrait,
    setIsLandscape,
    setIsMobileDevice,
    setMobilePlatform,
  }
})
